// pages/Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import {
    Box,
    TextField,
    Button,
    Typography,
    Container,
    Paper,
} from "@mui/material";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/tracker");
        } catch (err) {
            setError("Login failed. Check your credentials.");
            console.error(err);
        }
    };

    return (
        <Box
            sx={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                //backgroundImage: "url('https://images.unsplash.com/photo-1649073586428-e288125d930a?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')", // Replace with your image
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                textAlign: "center",
            }}
        >
            <Container maxWidth="sm">
                <Paper elevation={3} sx={{ mt: 10, p: 4 }}>
                    <Typography variant="h5" gutterBottom>Login</Typography>
                    <Box component="form" onSubmit={handleLogin} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <TextField label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                        <TextField label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                        <Button type="submit" variant="contained">Login</Button>
                        {error && <Typography color="error">{error}</Typography>}
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Login;